<form [formGroup]="checkboxesFormGroup">
  <side-panel-header [title]="'Employee filters' | translate" (closed)="close()" />

  @if (filters) {
    <div
      class="flex h-10 cursor-pointer items-center bg-surface pl-3 font-bold text-default"
      (click)="toggle('status')"
    >
      {{ 'Status' | translate }}
    </div>
    <div
      class="flex flex-col gap-xs p-md text-default"
      [formGroup]="asFormGroup(checkboxesFormGroup.controls['status'])"
    >
      <sb-checkbox formControlName="active">{{ 'Active' | translate }}</sb-checkbox>
      @if (canViewInactiveUsers$ | async) {
        <sb-checkbox formControlName="inactive">{{ 'Deactivated' | translate }}</sb-checkbox>
      }
      <sb-checkbox formControlName="invited">{{ 'Invited' | translate }}</sb-checkbox>
      <sb-checkbox formControlName="notInvited">{{ 'Not invited' | translate }}</sb-checkbox>
    </div>
    <ng-container *subscriptionPlan="planType.BASIC">
      @if (canViewContracts$ | async) {
        <div
          class="flex h-10 cursor-pointer items-center bg-surface pl-3 font-bold text-default"
          (click)="toggle('contract')"
        >
          {{ 'Contract types' | translate }}
        </div>
        <div
          class="flex flex-col gap-xs p-md text-default"
          [formGroup]="asFormGroup(checkboxesFormGroup.controls['contract'])"
        >
          <sb-checkbox formControlName="noContract">{{ 'No active contract' | translate }}</sb-checkbox>
          @for (contractType of contractTypes; track contractType.id) {
            <sb-checkbox [formControlName]="contractType.id" [complexLabel]="true">
              <span
                class="truncate"
                sbTruncated
                #truncated="sbTruncated"
                [sbTooltip]="contractType.name"
                [sbTooltipDisabled]="!truncated.isTruncated()"
                sbTooltipNoDescription
              >
                {{ contractType.name }}
              </span>
            </sb-checkbox>
          }
        </div>
      }
    </ng-container>
    @if (canViewPermissions$ | async) {
      <div
        class="flex h-10 cursor-pointer items-center bg-surface pl-3 font-bold text-default"
        (click)="toggle('group')"
      >
        {{ 'Permission groups' | translate }}
      </div>
      <div
        class="flex flex-col gap-xs p-md text-default"
        [formGroup]="asFormGroup(checkboxesFormGroup.controls['group'])"
      >
        @for (permissionGroup of permissionGroups; track permissionGroup.id) {
          <sb-checkbox [formControlName]="permissionGroup.id">{{ permissionGroup.name }}</sb-checkbox>
        }
      </div>
    }
    <ng-container *subscriptionPlan="planType.PREMIUM">
      @if ((canViewSkills$ | async) && skills().length > 0) {
        <section>
          <header class="flex h-10 items-center bg-surface pl-3 font-bold text-default">
            {{ 'Skills' | translate }}
          </header>
          <div class="p-md text-default">
            <sb-checkbox-tree [items]="skills()" [canSelectAll]="true" formControlName="skills" />
          </div>
        </section>
      }
    </ng-container>
  }
</form>
